import { compose, createStore, combineReducers, applyMiddleware } from 'redux'
import { createBrowserHistory } from 'history'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import undoable, { excludeAction, groupByActionTypes } from 'redux-undo'
import ReduxThunk from 'redux-thunk'
import ProductsReducer from '../reducers/ProductsReducer'
import isLoading from '../reducers/LoadingReducer'

function logger({ getState }) {
  return (next) => (action) => {
    const returnValue = next(action)
    console.log(action, getState())
    return returnValue
  }
}
function rootReducer(state = {}, action) {
  // loading
  if (action.type !== 'TOGGLE_LOADING' && state && state.isLoading) {
    return state
  }
  return reducers(state, action)
}

const reducers = combineReducers({
  isLoading,
  //products: ProductsReducer,
  products: undoable(ProductsReducer, {
    // undoType: 'UNDO_PRODUCTS',
    // redoType: 'REDO_PRODUCTS',
    groupBy: groupByActionTypes(['TOGGLE_PRODUCTS_LOADING']),
    filter: excludeAction([
      '@@router/LOCATION_CHANGE',
      'SET_PER_PAGE',
      'SET_ACTIVE_PAGE',
      'SET_TOTAL_PAGES',
      'SET_PRODUCTS_FILTERS',
      'TOGGLE_PRODUCTS_LOADING',
      'TOGGLE_FILTER',
      'TOGGLE_ACTIVE_FILTERS',
    ]),
  }),
})

export const history = createBrowserHistory({
  basename: window.pathURL,
})
export let store = createStore(
  connectRouter(history)(rootReducer),
  compose(
    applyMiddleware(
      routerMiddleware(history), // for dispatching history actions
      ReduxThunk,
      logger
    )
  )
)
